<div class="td-wb-icon-button__content">
  @if (iconButtonLabelText() !== undefined) {
    <span class="td-wb-icon-button__label"
          [class.td-wb-icon-button__label--active]="active()"
          [class.td-wb-icon-button__label--top]="iconButtonLabelPosition() === 'top'"
          [class.td-wb-icon-button__label--small-bold]="iconButtonLabelSize() === 'small-bold'"
          [class.td-wb-icon-button__label--large]="iconButtonLabelSize() === 'large'"
          [class.td-wb-icon-button__label--large-bold]="iconButtonLabelSize() === 'large-bold'"
          [innerText]="iconButtonLabelText()"></span>
  }
  <ng-content />
</div>
@if (showSpinner()) {
  <td-wb-spinner class="td-wb-icon-button__spinner-icon" />
}
